var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters)?_c('ul',{staticClass:"vuw-no-bullet vuw-filter-item-list"},_vm._l((_vm.filters),function(filter){return _c('checkbox',{key:filter.FilterCodeName,attrs:{"item":filter},on:{"change":_vm.trackCheckboxOptionsClick}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }